import { createFileRoute } from '@tanstack/react-router'
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
import Header from '@ui/components/header'

import Certificates from '../components/certificates'

// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved

export const Route = createFileRoute('/certificates')({
  component: () => {
    return (
      <div className="w-full flex flex-col">
        <Header showHero={false} />
        <Certificates />
      </div>
    )
  }
})
